import documentsFilter from '@/store/documentsFilter'

export default {
  namespaced: true,

  state: () => {
    return {
      ...documentsFilter.state(),
    }
  },

  getters: {
    ...documentsFilter.getters,
  },

  mutations: {
    ...documentsFilter.mutations,
  },
}
